import { LandingPageDesignAccess } from 'lib/api/superadmin/landingPageDesigns/useQueryLandingPageDesigns';
import { IResellerCustomerInfo } from '../types';

export const transformLandingPageDesignAccess = (
  selectedTemplateDesignId: number | null,
  templateDesignAccess: LandingPageDesignAccess[] | undefined
) => {
  if (!selectedTemplateDesignId || !templateDesignAccess) {
    return;
  }
  // all resellers and customers that should be pre-selected
  let initialResellerCustomerObject: IResellerCustomerInfo = {};

  // add resellers first
  templateDesignAccess.forEach((lpAccess: LandingPageDesignAccess) => {
    const resellerId = lpAccess?.reseller
      ? lpAccess.reseller.resellerId
      : Number(lpAccess.customer.resellerId);

    initialResellerCustomerObject[resellerId] = {
      resellerName: lpAccess?.reseller?.resellerName || '',
      totalCustomerCount: 0,
      isResellerSelected: !!lpAccess.reseller,
      selectedCustomers: {},
    };
  });

  // add selected customers
  templateDesignAccess
    .filter(designAccess => !designAccess.reseller)
    .forEach(access => {
      const resellerId = Number(access.customer.resellerId);
      const customerId = Number(access.customer.customerId);
      const isDefault =
        access.customer.defaultLandingPageDesignId === selectedTemplateDesignId
          ? 1
          : 0;

      initialResellerCustomerObject[resellerId].selectedCustomers[customerId] =
        {
          default: isDefault,
        };
    });

  return initialResellerCustomerObject;
};
